import React, { useEffect, createElement } from 'react';
/**
 * Share / SEO metadata for the Fuel Up & Play deck.
 *
 * The build environment owns the static index.html, so we set the document
 * title and inject/refresh the relevant <meta> tags at runtime instead.
 *
 * NOTE: Most social scrapers (iMessage, Slack, LinkedIn, etc.) do not execute
 * JavaScript, so for guaranteed link previews the canonical tags should also be
 * added to the published page's <head> via the PUBLISH settings. These runtime
 * tags cover in-browser title/theming and any JS-aware crawlers.
 */
const META = {
  title: 'Fuel Up & Play — Freeplay Contests to Build Loyalty | Chalkline',
  description: 'Turn 3 to 5 minutes at the pump into high-engagement casino and travel-center foot traffic. Free-to-play contests, fully managed by Chalkline — you only handle the prizes.',
  siteName: 'Chalkline',
  url: 'https://chalkline.com',
  // Swap this for a hosted 1200×630 share image via PUBLISH for the best preview.
  image: '',
  themeColor: '#0a0a0a',
  accentColor: '#22c55e'
};
type MetaTag = {
  attr: 'name' | 'property';
  key: string;
  content: string;
};
function upsertMeta({
  attr,
  key,
  content
}: MetaTag) {
  if (!content) return;
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function Meta() {
  useEffect(() => {
    document.title = META.title;
    const tags: MetaTag[] = [{
      attr: 'name',
      key: 'description',
      content: META.description
    }, {
      attr: 'name',
      key: 'theme-color',
      content: META.themeColor
    },
    // Open Graph
    {
      attr: 'property',
      key: 'og:title',
      content: META.title
    }, {
      attr: 'property',
      key: 'og:description',
      content: META.description
    }, {
      attr: 'property',
      key: 'og:type',
      content: 'website'
    }, {
      attr: 'property',
      key: 'og:site_name',
      content: META.siteName
    }, {
      attr: 'property',
      key: 'og:url',
      content: META.url
    }, {
      attr: 'property',
      key: 'og:image',
      content: META.image
    },
    // Twitter
    {
      attr: 'name',
      key: 'twitter:card',
      content: META.image ? 'summary_large_image' : 'summary'
    }, {
      attr: 'name',
      key: 'twitter:title',
      content: META.title
    }, {
      attr: 'name',
      key: 'twitter:description',
      content: META.description
    }, {
      attr: 'name',
      key: 'twitter:image',
      content: META.image
    }];
    tags.forEach(upsertMeta);
  }, []);
  return null;
}